/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
export const _arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

export const getBase64 = <T>(file: File, readType: "dataURL" | "text") => {
  return new Promise<T>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result as unknown as T);
    reader.onerror = (error) => reject(error);

    if (readType === "dataURL") {
      reader.readAsDataURL(file);
    }
    if (readType === "text") {
      reader.readAsText(file, "ISO-8859-1");
    }
  });
};
